import * as React from "react";
import { ChevronDown } from "lucide-react";
import { Collapsible, Input } from "@/components/ui";
import { BuilderState, FormRouteBuilder } from "../useFormRouteBuilder";
import { RouteCard, STEP_IDS } from "./RouteCard";

interface Props {
  state: BuilderState;
  setUtm: FormRouteBuilder["setUtm"];
}

export function FormCardCampaign({ state, setUtm }: Props) {
  return (
    <RouteCard
      step={4}
      id={STEP_IDS.campaign}
      title="Campaign tracking"
      description="Saved on every form link this route creates, so Form Links and responses show where they came from."
    >
      <Collapsible className="flex flex-col gap-3">
        <div className="flex flex-col sm:flex-row sm:items-end gap-3">
          <label className="flex flex-1 flex-col gap-1.5 text-sm font-medium text-slate-700">
            Campaign
            <Input
              value={state.utm.campaign}
              onChange={e => setUtm("campaign", e.target.value)}
              placeholder="e.g. post-close-survey"
            />
          </label>
          <Collapsible.Trigger className="group flex h-9 items-center gap-1 text-sm font-medium text-slate-600 hover:text-slate-900 cursor-pointer">
            <ChevronDown className="size-4 transition-transform group-data-[panel-open]:rotate-180" />
            Source and medium
          </Collapsible.Trigger>
        </div>
        <Collapsible.Content className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <label className="flex flex-col gap-1.5 text-sm font-medium text-slate-700">
            Source
            <Input value={state.utm.source} onChange={e => setUtm("source", e.target.value)} className="font-mono" />
          </label>
          <label className="flex flex-col gap-1.5 text-sm font-medium text-slate-700">
            Medium
            <Input value={state.utm.medium} onChange={e => setUtm("medium", e.target.value)} className="font-mono" />
          </label>
        </Collapsible.Content>
      </Collapsible>
    </RouteCard>
  );
}
